import { IUserMessageProps } from 'interfaces/ChatTab/chatTab';

const UserMessage = ({ message, day }: IUserMessageProps) => {
  const date = new Date(day);
  const time = date.toLocaleString('en-US', {
    hour: 'numeric',
    hour12: true,
    minute: 'numeric',
  });
  const dateAndMonth = `${date.getDate()} ${date.toLocaleString('en-us', {
    month: 'short',
  })}`;
  return (
    <div className="rounded-lg mt-1 mb-4 flex justify-end break-words">
      <div className=" min-w-[200px] max-w-[280px]">
        <div className="border-t-[0px]  border-[#FFF6A7] border-r-white border-t-transparent float-right border-b-[15px] border-b-transparent border-l-[20px]"></div>
        <div className="bg-[#FFF6A7]  mr-3 rounded-tr-sm  rounded-l-lg rounded-br-lg ">
          <div className="pl-2">
            <p className="break-words ">{message}</p>
          </div>
          <div className="flex items-center">
            {day ? (
              <div className="flex w-full justify-end items-center pr-2 text-xs ">{`${dateAndMonth} ${time}`}</div>
            ) : (
              <div className="flex space-x-1 w-full justify-end p-2 items-center mr-2 animate-pulse">
                <div className="h-1 w-1 bg-gray-400 rounded-full"></div>
                <div className="h-1 w-1 bg-gray-400 rounded-full"></div>
                <div className="h-1 w-1 bg-gray-400  rounded-full"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMessage;
